import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import api from "../lib/api";
import { useStore } from "../context/StoreContext";
import { ProductCard } from "../components/ProductCard";
import { Button } from "../components/ui/button";

export default function Wishlist() {
  const { wishlist } = useStore();
  const [products, setProducts] = useState([]);

  useEffect(() => {
    api.get("/products").then((r) => setProducts(r.data.filter((p) => wishlist.includes(p.slug))));
  }, [wishlist]);

  return (
    <div className="max-w-7xl mx-auto px-4 lg:px-8 py-12 fade-in">
      <div className="mb-8">
        <span className="text-xs uppercase tracking-[0.3em] text-gold">Saved for Later</span>
        <h1 className="font-serif text-5xl text-forest mt-1">Your Wishlist</h1>
      </div>
      {products.length === 0 ? (
        <div className="text-center py-24" data-testid="wishlist-empty">
          <Heart size={48} className="text-muted-foreground/30 mx-auto mb-4" />
          <p className="text-muted-foreground mb-6">Your wishlist is empty. Start adding your favourites!</p>
          <Link to="/products"><Button className="bg-forest text-cream rounded-full">Browse Products</Button></Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8" data-testid="wishlist-grid">
          {products.map((p) => <ProductCard key={p.id} product={p} />)}
        </div>
      )}
    </div>
  );
}
